export enum ModelPurpose {
  SOURCE_ACCESS = "source_access",
  SOURCE_RECORD_EXTRACTION = "source_record_extraction",
  REVIEW_LABEL = "review_label",
  // WB-1571 (ADR-0102): pre-triage of one non-material Identity Review.
  IDENTITY_ADJUDICATION = "identity_adjudication",
  // ADR-0125: ranks one Company's rule-scored Spark candidates.
  SPARK_TRIAGE = "spark_triage",
  DETECTION_PROPOSAL = "detection_proposal",
  BRIEF = "brief",
  // Owner decision 6 (2026-10-13): the Company Profile's company type,
  // services and franchise, read from the Company's captured pages.
  WEBSITE_CLASSIFICATION = "website_classification",
  // The Digest Tuner's draft reason for one File Change; operational only,
  // outside the Terminal Policy's promptRefs. The Digest itself lists the
  // Score Inputs that moved each score, with no model call.
  DIGEST = "digest",
}

export const dataByModelPurpose: Record<ModelPurpose, { label: string }> = {
  [ModelPurpose.SOURCE_ACCESS]: { label: "Source access" },
  [ModelPurpose.SOURCE_RECORD_EXTRACTION]: { label: "Record extraction" },
  [ModelPurpose.REVIEW_LABEL]: { label: "Review labels" },
  [ModelPurpose.IDENTITY_ADJUDICATION]: { label: "Identity adjudication" },
  [ModelPurpose.SPARK_TRIAGE]: { label: "Spark triage" },
  [ModelPurpose.DETECTION_PROPOSAL]: { label: "Detection proposals" },
  [ModelPurpose.BRIEF]: { label: "Brief" },
  [ModelPurpose.WEBSITE_CLASSIFICATION]: { label: "Website classification" },
  [ModelPurpose.DIGEST]: { label: "Digest" },
}
